import { render, staticRenderFns } from "./pageSwitcher.vue?vue&type=template&id=16c0021f&"
import script from "./pageSwitcher.vue?vue&type=script&lang=ts&"
export * from "./pageSwitcher.vue?vue&type=script&lang=ts&"
import style0 from "./pageSwitcher.vue?vue&type=style&index=0&module=true&lang=css&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VSheet})
